(() => {
  const desktopHover = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const refreshCartBubble = async () => {
    const response = await fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();
    const bubble = document.querySelector('#cart-icon-bubble');
    if (!bubble) return;
    let countBubble = bubble.querySelector('.cart-count-bubble');
    if (cart.item_count > 0) {
      if (!countBubble) {
        countBubble = document.createElement('div');
        countBubble.className = 'cart-count-bubble';
        bubble.appendChild(countBubble);
      }
      let count = countBubble.querySelector('[aria-hidden="true"]');
      if (!count) {
        count = document.createElement('span');
        count.setAttribute('aria-hidden', 'true');
        countBubble.appendChild(count);
      }
      count.textContent = cart.item_count < 100 ? String(cart.item_count) : '';
      let screenReader = countBubble.querySelector('.visually-hidden');
      if (!screenReader) {
        screenReader = document.createElement('span');
        screenReader.className = 'visually-hidden';
        countBubble.appendChild(screenReader);
      }
      screenReader.textContent = `Cart count: ${cart.item_count}`;
    } else {
      countBubble?.remove();
    }
  };
  const initAjaxCart = (root = document) => {
    root.querySelectorAll('[data-ajax-add-to-cart]').forEach((form) => {
      if (form.dataset.ajaxBound === 'true') return;
      form.dataset.ajaxBound = 'true';
      const button = form.querySelector('button[type="submit"]');
      const status = form.querySelector('[data-cart-status]');
      const originalLabel = button?.textContent?.trim() || 'Add to cart';
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const variantId = Number(form.querySelector('[name="id"]')?.value);
        if (!variantId || !button) return;
        button.disabled = true;
        button.textContent = 'Adding…';
        status.textContent = '';
        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
          });
          if (!response.ok) throw new Error('Unable to add this wine to the cart.');
          button.textContent = 'Added';
          status.textContent = 'Wine added to cart.';
          await refreshCartBubble();
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          window.setTimeout(() => {
            button.textContent = originalLabel;
            status.textContent = '';
          }, 2000);
        } catch (error) {
          button.textContent = originalLabel;
          status.textContent = 'Could not add this wine. Please try again.';
        } finally {
          button.disabled = false;
        }
      });
    });
  };
  const initCards = (root = document) => {
    root.querySelectorAll('[data-flip-card]').forEach((card) => {
      if (card.dataset.flipBound === 'true') return;
      card.dataset.flipBound = 'true';
      const open = card.querySelector('[data-flip-open]');
      const close = card.querySelector('[data-flip-close]');
      const setState = (state) => {
        card.classList.toggle('is-flipped', state);
        open?.setAttribute('aria-expanded', String(state));
      };
      let gesture = null;
      let suppressClickUntil = 0;
      card.addEventListener('touchstart', (event) => {
        if (event.touches.length !== 1 || event.target.closest('button, input, select, textarea, [data-flip-close]')) {
          gesture = null;
          return;
        }
        const touch = event.touches[0];
        gesture = { x: touch.clientX, y: touch.clientY, id: touch.identifier, vertical: false };
      }, { passive: true });
      card.addEventListener('touchmove', (event) => {
        if (!gesture) return;
        if (event.touches.length !== 1) { gesture = null; return; }
        const touch = event.touches[0];
        const dx = Math.abs(touch.clientX - gesture.x);
        const dy = Math.abs(touch.clientY - gesture.y);
        if (dy > 12 && dy > dx) gesture.vertical = true;
      }, { passive: true });
      card.addEventListener('touchcancel', () => { gesture = null; }, { passive: true });
      card.addEventListener('touchend', (event) => {
        const start = gesture;
        gesture = null;
        if (!start || start.vertical) return;
        const touch = Array.from(event.changedTouches).find(t => t.identifier === start.id);
        if (!touch) return;
        const dx = Math.abs(touch.clientX - start.x);
        const dy = Math.abs(touch.clientY - start.y);
        if (dx >= 48 && dx > dy * 1.5) {
          suppressClickUntil = Date.now() + 500;
          setState(!card.classList.contains('is-flipped'));
        }
      }, { passive: true });
      card.addEventListener('click', (event) => {
        if (Date.now() < suppressClickUntil) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
      open?.addEventListener('click', (event) => {
        if (desktopHover()) return;
        event.preventDefault();
        setState(true);
      });
      close?.addEventListener('click', (event) => {
        event.preventDefault();
        setState(false);
      });
      card.addEventListener('mouseleave', () => {
        if (desktopHover()) setState(false);
      });
      card.addEventListener('keydown', (event) => {
        if (event.target !== card) return;
        if (event.key === 'Enter' || event.key === ' ') {
          if (desktopHover()) return;
          event.preventDefault();
          setState(!card.classList.contains('is-flipped'));
        }
        if (event.key === 'Escape') setState(false);
      });
      document.addEventListener('click', (event) => {
        if (!card.classList.contains('is-flipped')) return;
        if (card.contains(event.target)) return;
        setState(false);
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { initCards(); initAjaxCart(); }, { once: true });
  } else {
    initCards();
    initAjaxCart();
  }
})();
